var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import ChatContainer from "./components/ChatContainer/ChatContainer";
import chatBotApi from "./api/chatbot";
import { setCategories, currentSessionId, setSessionId, setLanguage, currentLanguage, isLeadGenerationSubmitted, getAnswerReport } from "./stores/reducers/chatReducer";
import { useDispatch, useSelector } from "react-redux";
import { getSettings } from "./constants/setting";
import LeadGenerationForm from "./components/LeadGenerationForm/LeadGenerationForm";
import AnswerReport from "./components/AnswerReport/AnswerReport";
import LoadingPageIndicator from "./components/LoadingPageIndicator/LoadingPageIndicator";
var Index = function () {
    var dispatch = useDispatch();
    var answerReport = useSelector(getAnswerReport);
    var isLeadGenerationCompleted = useSelector(isLeadGenerationSubmitted);
    var sessionId = useSelector(currentSessionId);
    var getCurrentLanguage = useSelector(currentLanguage);
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _j = getSettings(), enable_lead_generation = _j.enable_lead_generation, language = _j.language, enable_answer_feedbacks = _j.enable_answer_feedbacks;
    var getBotSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, chatBotApi.getBotSetting(language).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    window.alwayson_settings = response.data;
                                    return [4 /*yield*/, startSession()];
                                case 1:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }).catch(function (err) {
                        console.error(err);
                        console.error('something went wrong!');
                    })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var startSession = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(!sessionId || getCurrentLanguage !== language)) return [3 /*break*/, 4];
                    if (!enable_lead_generation) return [3 /*break*/, 1];
                    setIsLoading(false);
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, chatBotApi.startSession().then(function (response) {
                        dispatch(setLanguage(language));
                        dispatch(setSessionId(response.data.session_id || ''));
                        dispatch(setCategories(response.data.categories || []));
                    }).catch(function (err) {
                        var _b;
                        console.error((_b = err.response.data) === null || _b === void 0 ? void 0 : _b.message);
                        console.error(err.response.status === 404 ? 'Invalid chatbot id' : 'something went wrong!');
                    }).finally(function () {
                        setIsLoading(false);
                    })];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getBotSettings();
    }, []);
    // Function to send a message to the parent component
    var sendMessageToParent = function () {
        var _b;
        // Send the message to the parent component
        window.parent.postMessage('minimize_chat', (_b = window.location.ancestorOrigins) === null || _b === void 0 ? void 0 : _b[0]);
    };
    var escFunction = function (event) {
        if (event.key === "Escape") {
            // Call the function to send a message to the parent when needed
            sendMessageToParent();
        }
    };
    useEffect(function () {
        document.addEventListener("keydown", escFunction, false);
    }, []);
    return _jsx(_Fragment, { children: isLoading ? _jsx(LoadingPageIndicator, {}) : _jsxs(_Fragment, { children: [(answerReport === null || answerReport === void 0 ? void 0 : answerReport.show) && enable_answer_feedbacks && _jsx(AnswerReport, {}), !enable_lead_generation || isLeadGenerationCompleted ? _jsx(ChatContainer, {}) : _jsx(LeadGenerationForm, {})] }) });
};
export default Index;
